import React from 'react';
import { styles } from '../styles';

const ErrorState = ({ message, onRetry }) => {
  return (
    <div style={styles.errorContainer}>
      <div style={styles.errorBox}>
        <h3 style={styles.errorTitle}>Error Loading Policy</h3>
        <p style={styles.errorMessage}>{message}</p>
        {onRetry && (
          <button
            onClick={onRetry}
            style={styles.errorButton}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = '#c82333';
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = '#dc3545';
            }}
          >
            Retry
          </button>
        )}
      </div>
    </div>
  );
};

export default ErrorState;
